var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"white--text",attrs:{"rounded":"","color":"fzPink","elevation":"4","disabled":_vm.isDisabled},on:{"click":_vm.navigate}},[_vm._v(" "+_vm._s(_vm.$t('nav.continue'))+" "),_c('v-icon',{attrs:{"right":""}},[_vm._v(_vm._s(_vm.iconNextArrow))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }